AsideMenu;

import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Switch,
} from "@mui/material";
import { useContext, useState } from "react";
import { DashboardContext } from "../../modules/dashboard/context/DashboardContexProvider";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";
import { useNavigate } from "react-router-dom";
import { CardsAdder } from "./CardsAdder";
import { ropTheme, darkTheme, lightTheme, darkThemeTwo, lightThemeTwo } from "../themes/themes";
import { loginApi, usersApi } from "../../services/api";
import { getDefaultCardsConfig } from "../themes/defaultLayout";
import {
  MdOutlineDashboard,
  MdOutlineNightlight,
  MdOutlinePeopleAlt,
  MdOutlineWbSunny,
  MdOutlineNotificationAdd,
} from "react-icons/md";
import { AiOutlineThunderbolt } from "react-icons/ai";
import { FaMapMarkerAlt, FaSolarPanel } from "react-icons/fa";
import { CiCircleQuestion } from "react-icons/ci";
import { FiLogOut } from "react-icons/fi";
import BrushIcon from "@mui/icons-material/Brush";
import { AsideMenuItem, AsideMenuItemProps } from "./AsideMenuItem";
import AsideMenuHeader from "./AsideMenuHeader";
export type AsideMenuProps = {
  backGroundIsBlur?: boolean;
};
import ReplayIcon from "@mui/icons-material/Replay";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { AsideMenuAccordionDashboardItem } from "./AsideMenuAccordionDashboardItem";
// import ListIcon from "@mui/icons-material/List";
import {
  defaultCardsDisplayableColorProps,
  defaultCardsDisplayableProps,
} from "../themes/defaultLayoutData";
import GroupsIcon from "@mui/icons-material/Groups";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { AsideMenuAccordionItem } from "./AsideMenuAccordionItem";
import EngineeringIcon from "@mui/icons-material/Engineering";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import BadgeIcon from "@mui/icons-material/Badge";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import SummarizeIcon from "@mui/icons-material/Summarize";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FilterCardModal, {
  CardFilterOptionsEnum,
} from "../../modules/dashboard/components/modal/FilterCardModal";
import { UsinaByClient } from "../../modules/usinas/types";
import {
  CardInfo,
  CardTypesEnum,
  GetRopCardParams,
} from "../../modules/dashboard/types";
import { formatDate, formatDateRequest } from "../utils/utils";
import { useRopV2AppNative } from "../../modules/ropv2app/context/RopV2AppNativeContext";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import CheckBoxTableRow from "../../modules/users/components/CheckBoxTableRow";
import CachedIcon from '@mui/icons-material/Cached';
import { ConfirmationModal } from "./ConfirmationModal";
import MovingIcon from '@mui/icons-material/Moving';
import BarChartIcon from '@mui/icons-material/BarChart';
import WaterfallChartIcon from '@mui/icons-material/WaterfallChart';
import BrightnessHighIcon from '@mui/icons-material/BrightnessHigh';

export default function AsideMenu(props: AsideMenuProps) {
  const {
    setLayoutsConfig,
    layoutsConfig,
    defaultLayouts,
    setCardsConfig,
    setCardsDisplayableProps,
    setCardsDisplayableColorProps,
    canEditLayout,
    setCanEditLayout,
    cardsConfig,
    setRequestParamCards,
  } = useContext(DashboardContext);

  const {
    theme,
    setTheme,
    setUser,
    asideMenuIsShrunken,
    setAsideMenuIsShrunken,
    asideMenuWidth,
    selectedDashboardClient: selectedClient,
    selectedDashboardUsina: selectedUsina,
    layout,
    setLayout,
    userClients,
    clientMenuResources,
    toastNotifications,
    setToastNotifications,
    user
  } = useContext(MainContext);

  const { pushDeviceId } = useRopV2AppNative();

  async function logout() {
    await loginApi.logout({
      pushDeviceId: pushDeviceId || undefined,
    });
    setUser(undefined);
    navigate("/login");
  }

  const [openConfirmationLayoutModal, setOpenConfirmationLayoutModal] = useState(false);

  const handleConfirmSave = async () => {
    try {
      await usersApi.resetUsersLayouts()

      if (user) {
        const response = await usersApi.getUser(user?.userId)

        let updatedUser = user;

        if (response.resetLayout) {
          setCardsConfig(getDefaultCardsConfig());
          setLayoutsConfig(defaultLayouts);
          setCardsDisplayableProps(defaultCardsDisplayableProps);

          try {
            await usersApi.resetLayoutToFalse(user.userId);
            updatedUser.resetLayout = false
          }
          catch (_err) {
            updatedUser.resetLayout = response.resetLayout ?? false
          }
        }

        setUser(updatedUser)
      }

      const newNotifications = {
        isAdding: true,
        notifications: [
          ...toastNotifications.notifications,
          {
            severity: "success" as const,
            text: `Layouts de usuários resetados com sucesso`,
          },
        ],
      };
      setToastNotifications(newNotifications);
    } catch (_err) {
      const newNotifications = {
        isAdding: true,
        notifications: [
          ...toastNotifications.notifications,
          {
            severity: "error" as const,
            text: `Houve um erro ao resetar os layouts dos usuários, tente novamente!`,
          },
        ],
      };
      setToastNotifications(newNotifications);
    }
  }

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [dateFilter, setDateFilter] = useState<CardFilterOptionsEnum>(
    CardFilterOptionsEnum.Live
  );
  const [date, setDate] = useState<Date | null>(new Date());

  const onConfirmFilterModal = () => {
    sendAllDashboardHistoryParams(
      selectedUsina,
      date,
      dateFilter,
      cardsConfig,
      setRequestParamCards
    );
    setOpenFilterModal(false);
  };

  const isDashboard = window.location.pathname.includes("/dashboard");
  const isDashboardEdit = window.location.pathname.includes("/dashboard/edit");

  const items: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <AiOutlineThunderbolt style={style} />,
      title: "Tema Rop",
      onClick: () => {
        setTheme(ropTheme);
      },
      cantShow: true,
    },
    {
      icon: (style) => <NotificationImportantIcon style={style} />,
      title: "Alarmes",
      route: "/alarm/equipment-alarms-list",
      URI: "/Alarms/current/{usinaId}"
    },
    //TODO: o acesso ao menu de centro de operações foi hardcoded temporariamente para apresentação do novo módulo, devemos atualizar os bancos de acordo com os perfis que devem acessar, e remover a escrita hardcoded

    {
      icon: (style) => <WaterfallChartIcon style={style} />,
      title: "Centro de Operações Solar",
      route: "/operations/center",
      URI: "/operations/center"
    },
    {
      icon: (style) => <AssignmentIcon style={style} />,
      title: "Solicitações de Serviço",
      route: "/service-request/list",
      URI: "/Sismetro"
    },
    {
      icon: (style) => <SolarPowerIcon style={style} />,
      title: "Detalhes da Usina",
      route: `usinas/details/${selectedUsina?.usinaIds.id}`,
      URI: "/Usina/{usinaId}"
    },
  ];
  const adminItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <FaSolarPanel style={style} />,
      title: "Usinas",
      route: "/usinas",
      URI: "/Usina"
    },

    {
      icon: (style) => <GroupsIcon style={style} />,
      title: "Clientes",
      route: "/clients",
      URI: "/Clients"
    },
    {
      icon: (style) => <MdOutlinePeopleAlt style={style} />,
      title: "Usuários",
      route: "/users",
      URI: "/User"
    },
    {
      icon: (style) => <MdOutlineNotificationAdd style={style} />,
      title: "Matriz de Alarmes",
      route: "/alarm/matriz",
      URI: "/Alarms/all-alarms"
    },
    {
      icon: (style) => <ReceiptLongIcon style={style} />,
      title: "Relatórios",
      route: "/usinas/relatorios",
      URI: "/relatorios"
    },
    {
      icon: (style) => <ManageSearchIcon style={style} />,
      title: "Análise de Consultas",
      route: "/sql-queries",
      URI: "/sql-queries"
    },
    {
      icon: (style) => <BrightnessHighIcon style={style} />,
      title: "Controle de Rede Solar",
      route: "/operations/control",
      URI: "/operations/control"
    }
  ];

  const boletimItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <AssessmentIcon style={style} />,
      title: "Boletim Diário",
      route: "/usinas/boletim-diario",
      URI: "/Relatorios/diario-info"
    },
    {
      icon: (style) => <SummarizeIcon style={style} />,
      title: "Boletim Mensal",
      route: "/usinas/boletim-mensal",
      URI: "/Relatorios/diario-mensal"
    },
    {
      icon: (style) => <AssessmentIcon style={style} />,
      title: "Boletim Personalizado",
      route: "/usinas/boletim-personalizado",
      URI: "/Relatorios/personalizado"
    },
    {
      icon: (style) => <MovingIcon style={style} />,
      title: "Boletim Parcial",
      route: "/usinas/boletim-parcial",
      URI: "/Relatorios/parcial"
    },
  ];

  const myDataItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <ManageAccountsIcon style={style} />,
      title: "Perfil",
      route: "/perfil",
      URI: "/User/{id}"
    },
    {
      icon: (style) => <BadgeIcon style={style} />,
      title: "Detalhes do cliente",
      route: `clients/${selectedClient?.id}`,
      URI: "/Clients/{id}"
    },
  ];
  const dashboardItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <ReplayIcon style={style} />,
      title: "Layout Padrão",
      onClick: () => {
        setCardsConfig(getDefaultCardsConfig());
        setLayoutsConfig(defaultLayouts);
        setCardsDisplayableProps(defaultCardsDisplayableProps);
      },
      cantShow: isDashboardEdit,
      disabled: !canEditLayout,
    },
    {
      icon: (style) => <CachedIcon style={style} />,
      title: "Restaurar layout de usuários",
      onClick: () => {
        setOpenConfirmationLayoutModal(true)
      },
      cantShow: !userClients?.find(clients => clients.id == "656f0f50583fe04b0a62fc3d"),
      disabled: !canEditLayout,
    },
    {
      icon: (style) => <FormatPaintIcon style={style} />,
      title: "Cores Padrões",
      onClick: () => {
        setCardsDisplayableColorProps(defaultCardsDisplayableColorProps);
        // location.reload();
      },
      cantShow: isDashboardEdit,
      disabled: !canEditLayout,
    },
    {
      icon: (style) => <RemoveCircleOutlineIcon style={style} />,
      title: "Limpar Layout",
      onClick: () => {
        setLayoutsConfig({
          ...layoutsConfig,
          layouts: {
            lg: [],
            md: [],
            sm: [],
            xs: [],
            xxs: [],
          },
        });
        setCardsConfig([]);
      },
      cantShow: isDashboardEdit,
      disabled: !canEditLayout,
    },
  ];

  const bottomItems: Omit<AsideMenuItemProps, "isShrunken">[] = [
    {
      icon: (style) => <MdOutlineNightlight style={style} />,
      title: "Tema Dark",
      onClick: () => {
        setTheme(layout == LayoutsConfig.LayoutOne ? darkTheme : darkThemeTwo);
      },
    },
    {
      icon: (style) => <MdOutlineWbSunny style={style} />,
      title: "Tema Light",
      onClick: () => {
        setTheme(layout == LayoutsConfig.LayoutOne ? lightTheme : lightThemeTwo);
      },
    },
    {
      icon: (style) => <FiLogOut style={style} />,
      title: "Sair",
      onClick: logout,
    },
  ];

  const canShowAdminItems = adminItems.filter((item) => !item.cantShow)
  const displayableAdminItems = canShowAdminItems.filter((item) => clientMenuResources.some(resource => resource.uri || "/operations/center" === item.URI));

  const canShowMyDataItems = myDataItems.filter((item) => !item.cantShow)
  const displayableMyDataItems = canShowMyDataItems.filter((item) => clientMenuResources.some(resource => resource.uri === item.URI));

  const canShowItems = items.filter((item) => !item.cantShow)
  const displayableItems = canShowItems.filter((item) => clientMenuResources.some(resource => resource.uri === item.URI));

  const canShowDashboardItems = dashboardItems.filter(
    (item) => !item.cantShow
  );
  const displayableDashboardItems = canShowDashboardItems

  const canShowBoletimItems = boletimItems.filter((item) => !item.cantShow)
  const displayableBoletimItems = canShowBoletimItems.filter((item) => clientMenuResources.some(resource => resource.uri === item.URI));

  const navigate = useNavigate();

  return (
    <Drawer
      // anchor="left"
      sx={{
        direction: "ltr",
        top: layout == LayoutsConfig.LayoutTwo ? "42px" : "0px",
        "& .MuiPaper-root": {
          backgroundColor: theme.asideMenuBackgroundColor,
          border: "none",
          top: layout == LayoutsConfig.LayoutTwo ? "42px" : "0px",
        },
      }}
      ModalProps={{ BackdropProps: { invisible: !props.backGroundIsBlur } }}
      variant={"permanent"}
    >
      <Box
        style={{
          width: asideMenuWidth,
          direction: "ltr",
          height: "100%",
          transition: "width 0.3s ease-in-out",
        }}
      >
        <AsideMenuHeader
          onClickTuneIcon={() => setOpenFilterModal(true)}
          isShrunken={asideMenuIsShrunken}
          setIsShrunken={setAsideMenuIsShrunken}
          isDashboard={isDashboard}
        />

        {/* PORTFÓLIO*/}

        {clientMenuResources.some(resource => resource.uri === "/Portfolio") && (
          <AsideMenuItem
            icon={(style) => <FaMapMarkerAlt style={style} />}
            title="Portfólio"
            route="/portfolio"
            isShrunken={asideMenuIsShrunken}
          />
        )}

        {/* DASHBOARD*/}
        {clientMenuResources.some(resource => resource.uri === "/Dashboard") && (
          <AsideMenuItem
            icon={(style) => <MdOutlineDashboard style={style} />}
            title="Dashboard"
            route="/dashboard"
            isShrunken={asideMenuIsShrunken}
          />
        )}
        {/* <Divider
          style={{
            backgroundColor: theme.secondaryTextColor,
          }}
          variant="middle"
        /> */}

        {/* BOTÕES*/}
        {displayableItems.map((item, index) => (
          <AsideMenuItem
            icon={item.icon}
            title={item.title}
            key={index}
            onClick={item.onClick}
            route={item.route}
            disabled={item.disabled}
            isShrunken={asideMenuIsShrunken}
          />
        ))}

        {/* BOTÕES COM ACCORDION*/}
        {displayableBoletimItems.length > 0 && (
          <AsideMenuAccordionItem
            icon={(style) => <BarChartIcon style={style} />}
            title="Boletim"
            isShrunken={asideMenuIsShrunken}
          >
            <>
              {displayableBoletimItems.map((item, index) => (
                <AsideMenuItem
                  icon={item.icon}
                  title={item.title}
                  key={index}
                  onClick={item.onClick}
                  route={item.route}
                  disabled={item.disabled}
                  isShrunken={asideMenuIsShrunken}
                  isAccordionitem
                />
              ))}
              <Divider
                style={{
                  backgroundColor: theme.secondaryTextColor,
                }}
                variant="middle"
              />
            </>
          </AsideMenuAccordionItem>
        )}
        {/* {userIsAdm && ( */}
        {clientMenuResources.some(resource => resource.uri === "/Administrativo") && (
          <AsideMenuAccordionItem
            icon={(style) => <EngineeringIcon style={style} />}
            title="Administrativo"
            isShrunken={asideMenuIsShrunken}
          >
            <>
              {displayableAdminItems.map((item, index) => (
                <AsideMenuItem
                  icon={item.icon}
                  title={item.title}
                  key={index}
                  onClick={item.onClick}
                  route={item.route}
                  disabled={item.disabled}
                  isShrunken={asideMenuIsShrunken}
                  isAccordionitem
                />
              ))}
              <Divider
                style={{
                  backgroundColor: theme.secondaryTextColor,
                }}
                variant="middle"
              />
            </>
          </AsideMenuAccordionItem>
        )}
        {layout == LayoutsConfig.LayoutOne &&
          <>
            {clientMenuResources.some(resource => resource.uri === "/Meus-dados") &&
              <AsideMenuAccordionItem
                icon={(style) => <FolderSharedIcon style={style} />}
                title="Meus dados"
                isShrunken={asideMenuIsShrunken}
              >
                <>
                  {displayableMyDataItems.map((item, index) => (
                    <AsideMenuItem
                      icon={item.icon}
                      title={item.title}
                      key={index}
                      onClick={item.onClick}
                      route={item.route}
                      disabled={item.disabled}
                      isShrunken={asideMenuIsShrunken}
                      isAccordionitem
                    />
                  ))}
                  <Divider
                    style={{
                      backgroundColor: theme.secondaryTextColor,
                    }}
                    variant="middle"
                  />
                </>
              </AsideMenuAccordionItem>}
            <AsideMenuItem
              icon={(style) => <CiCircleQuestion style={style} />}
              title="Dúvidas Frequentes - FAQ"
              route="/faq"
              isShrunken={asideMenuIsShrunken}
            /></>}

        {/* EDIÇÃO DO LAYOUT DO DASHBOARD*/}

        {clientMenuResources.some(resource => resource.uri === "/edicao-layout") &&
          <AsideMenuAccordionDashboardItem
            icon={(style) => <BrushIcon style={style} />}
            title={"Edição de Layout"}
            route={"/dashboard"}
            isShrunken={asideMenuIsShrunken}
            children={
              isDashboard &&
              !asideMenuIsShrunken && (
                <>
                  {!isDashboardEdit && (
                    <>
                      <ListItem disablePadding>
                        <ListItemButton
                          sx={{
                            borderRadius: "10px",
                            height: "45px",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "row",
                          }}
                          onClick={() => setCanEditLayout(!canEditLayout)}
                        >
                          <ListItemIcon>
                            <Switch
                              checked={canEditLayout}
                              onChange={(_, checked) => {
                                setCanEditLayout(checked);
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{
                              flex: "none",
                              WebkitFlex: "none",
                              width: "45px",
                            }}
                            primaryTypographyProps={{ fontSize: "14px" }}
                            primary={canEditLayout ? "Desabilitar" : "Habilitar"}
                          />
                        </ListItemButton>
                      </ListItem>
                      {canEditLayout && (
                        <CardsAdder isAccordionitem theme={theme} />
                      )}
                    </>
                  )}
                  {displayableDashboardItems.map(
                    (item, index) =>
                      canEditLayout && (
                        <AsideMenuItem
                          icon={item.icon}
                          title={item.title}
                          key={index}
                          onClick={item.onClick}
                          route={item.route}
                          disabled={item.disabled}
                          isShrunken={asideMenuIsShrunken}
                          isAccordionitem
                        />
                      )
                  )}
                </>
              )
            }
          />}
        <List>
          <Divider
            style={{
              backgroundColor: theme.secondaryTextColor,
            }}
            variant="middle"
          />
          {!asideMenuIsShrunken && userClients?.find(clients => clients.id == "656f0f50583fe04b0a62fc3d") &&
            <ListItem disablePadding>
              <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <CheckBoxTableRow active={layout == LayoutsConfig.LayoutOne} onChange={() => { setLayout(LayoutsConfig.LayoutOne) }} name="Layout 1" />
                <CheckBoxTableRow active={layout == LayoutsConfig.LayoutTwo} onChange={() => { setLayout(LayoutsConfig.LayoutTwo) }} name="Layout 2" />
              </Box>
            </ListItem>}
          {bottomItems.map((item, index) => (
            <AsideMenuItem
              key={index}
              icon={item.icon}
              title={item.title}
              onClick={item.onClick}
              isShrunken={asideMenuIsShrunken}
            />
          ))}
        </List>
      </Box>
      <ConfirmationModal
        open={openConfirmationLayoutModal}
        setOpen={() => setOpenConfirmationLayoutModal(false)}
        title="Resetar Layout de usuários"
        contentText="Deseja confirmar a reinicialização do layout de todos os usuários?"
        onConfirm={handleConfirmSave}
      />
      <FilterCardModal
        onConfirm={onConfirmFilterModal}
        open={openFilterModal ?? false}
        setOpen={setOpenFilterModal ?? (() => { })}
        title={"Filtro do Dashboard"}
        possibleDateFilters={[
          {
            label: "Live",
            value: CardFilterOptionsEnum.Live,
          },
          {
            label: "Dia",
            value: CardFilterOptionsEnum.Dia,
          },
          // OBS: Em desenvolvimento
          // {
          //   label: "Mes",
          //   value: CardFilterOptionsEnum.Mes,
          // },
          // {
          //   label: "Ano",
          //   value: CardFilterOptionsEnum.Ano,
          // },
        ]}
        setDateFilterType={setDateFilter ?? (() => { })}
        setDate={setDate ?? (() => { })}
        date={date ?? null}
        dateFilterType={dateFilter ?? null}
      />
    </Drawer >
  );
}

export function sendAllDashboardHistoryParams(
  selectedUsina: UsinaByClient | undefined,
  date: string | Date | null,
  filterType: CardFilterOptionsEnum | undefined,
  cardsConfig: CardInfo[],
  setRequestParamCards: (requestParamCards: string[]) => void
) {
  if (filterType === CardFilterOptionsEnum.Live) {
    setRequestParamCards([]);
    return;
  }
  if (
    formatDate(date ?? new Date()) !== formatDate(new Date()) &&
    selectedUsina?.usinaIds.ropInputId
  ) {
    const cardTypes = cardsConfig.map((card) => card.type);

    const differentCardTypes = cardTypes.filter(
      (value, index, self) => self.indexOf(value) === index
    );

    const removeCardsNoFilter = differentCardTypes.filter(
      (type) =>
        type !== CardTypesEnum.TensaoDeLinha &&
        CardTypesEnum.Tracker &&
        CardTypesEnum.Ambiente
    );

    const getParams: GetRopCardParams[] = removeCardsNoFilter.map((type) => {
      return {
        ropCardType: type == CardTypesEnum.GeracaoPlanta ? 13 : type,
        usinaId: selectedUsina?.usinaIds.ropInputId,
        date: formatDateRequest(date ?? new Date()),
        interval:
          filterType === CardFilterOptionsEnum.Hora ? 1 : Number(filterType),
      };
    });
    const converParamsToJSON = getParams.map((card) => JSON.stringify(card));
    setRequestParamCards(converParamsToJSON);
  }
}
